import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { type ILogbook } from "src/interfaces";
import { PageContainer } from "src/styled";

const mapLogbooks = (data: any) => {
  let list: ILogbook[] = [];
  if (data?.data?.content?.list) {
    list = data.data.content.list.map((el: ILogbook) => ({
      ...el,
      active: el.active ? "Yes" : null,
    }));
  }
  return { ...data?.data?.content, list };
};

const Logbooks = () => {
  const { data, isLoading } = useGetApi({
    request: "get-management",
    body: { _sect: "_logbooks" },
    mapper: mapLogbooks,
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <ManagementTable
        section="_logbooks"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Logbooks;
